export const getTabsState = (state) => state.tabs.tabsState;
